var _path, _path2, _path3, _path4, _g, _g2, _g3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeatureIcon01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_743_3970)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.2609 6.30469C29.9265 6.30469 29.6058 6.43753 29.3693 6.67399C29.1328 6.91045 29 7.23115 29 7.56556C29 7.89996 29.1328 8.22067 29.3693 8.45713C29.6058 8.69359 29.9265 8.82643 30.2609 8.82643C34.2724 8.83077 38.1183 10.4263 40.9549 13.2628C43.7915 16.0994 45.387 19.9454 45.3913 23.9569C45.3913 24.2913 45.5241 24.612 45.7606 24.8484C45.9971 25.0849 46.3178 25.2177 46.6522 25.2177C46.9866 25.2177 47.3073 25.0849 47.5437 24.8484C47.7802 24.612 47.913 24.2913 47.913 23.9569C47.908 19.2768 46.0467 14.7898 42.7373 11.4804C39.428 8.17108 34.941 6.30969 30.2609 6.30469Z",
    fill: "url(#paint0_linear_743_3970)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7397 58.0003H5.04407C4.70967 58.0003 4.38896 57.8675 4.1525 57.631C3.91604 57.3946 3.7832 57.0739 3.7832 56.7395V45.3916C3.78327 45.0573 3.91616 44.7366 4.15264 44.5002L15.5005 33.1524C15.7369 32.916 16.0576 32.7832 16.3919 32.7832C16.7262 32.7832 17.0469 32.916 17.2833 33.1524L21.0659 36.935C21.3023 37.1714 21.4351 37.4921 21.4351 37.8264C21.4351 38.1607 21.3023 38.4814 21.0659 38.7178L11.3484 48.4354V55.4786H27.7397C28.0741 55.4786 28.3948 55.6114 28.6313 55.8479C28.8678 56.0843 29.0006 56.4051 29.0006 56.7395C29.0006 57.0739 28.8678 57.3946 28.6313 57.631C28.3948 57.8675 28.0741 58.0003 27.7397 58.0003Z",
    fill: "url(#paint1_linear_743_3970)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0006 33.4121C33.0039 33.4121 36.2492 30.1662 36.2492 26.1621C36.2492 22.158 33.0039 18.9121 29.0006 18.9121C24.9973 18.9121 21.752 22.158 21.752 26.1621C21.752 30.1662 24.9973 33.4121 29.0006 33.4121Z",
    fill: "url(#paint2_linear_743_3970)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2609 12.6094C29.9265 12.6094 29.6058 12.7422 29.3693 12.9787C29.1328 13.2151 29 13.5358 29 13.8702C29 14.2046 29.1328 14.5254 29.3693 14.7618C29.6058 14.9983 29.9265 15.1311 30.2609 15.1311C32.6008 15.1341 34.844 16.065 36.4985 17.7195C38.1531 19.3741 39.084 21.6173 39.087 23.9572C39.087 24.2916 39.2198 24.6123 39.4563 24.8488C39.6927 25.0852 40.0134 25.2181 40.3478 25.2181C40.6822 25.2181 41.0029 25.0852 41.2394 24.8488C41.4759 24.6123 41.6087 24.2916 41.6087 23.9572C41.6054 20.9486 40.4087 18.0642 38.2813 15.9368C36.1539 13.8094 33.2695 12.6127 30.2609 12.6094Z",
    fill: "url(#paint3_linear_743_3970)"
  })), /*#__PURE__*/React.createElement("foreignObject", {
    x: 26,
    y: 3.30469,
    width: 24.9131,
    height: 24.9131
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(1.5px)",
      clipPath: "url(#bgblur_1_743_3970_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_743_3970)",
    "data-figma-bg-blur-radius": 3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.2609 6.30469C29.9265 6.30469 29.6058 6.43753 29.3693 6.67399C29.1328 6.91045 29 7.23115 29 7.56556C29 7.89996 29.1328 8.22067 29.3693 8.45713C29.6058 8.69359 29.9265 8.82643 30.2609 8.82643C34.2724 8.83077 38.1183 10.4263 40.9549 13.2628C43.7915 16.0994 45.387 19.9454 45.3913 23.9569C45.3913 24.2913 45.5241 24.612 45.7606 24.8484C45.9971 25.0849 46.3178 25.2177 46.6522 25.2177C46.9866 25.2177 47.3073 25.0849 47.5437 24.8484C47.7802 24.612 47.913 24.2913 47.913 23.9569C47.908 19.2768 46.0467 14.7898 42.7373 11.4804C39.428 8.17108 34.941 6.30969 30.2609 6.30469Z",
    fill: "#1D1D1D",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.2609 6.30469C29.9265 6.30469 29.6058 6.43753 29.3693 6.67399C29.1328 6.91045 29 7.23115 29 7.56556C29 7.89996 29.1328 8.22067 29.3693 8.45713C29.6058 8.69359 29.9265 8.82643 30.2609 8.82643C34.2724 8.83077 38.1183 10.4263 40.9549 13.2628C43.7915 16.0994 45.387 19.9454 45.3913 23.9569C45.3913 24.2913 45.5241 24.612 45.7606 24.8484C45.9971 25.0849 46.3178 25.2177 46.6522 25.2177C46.9866 25.2177 47.3073 25.0849 47.5437 24.8484C47.7802 24.612 47.913 24.2913 47.913 23.9569C47.908 19.2768 46.0467 14.7898 42.7373 11.4804C39.428 8.17108 34.941 6.30969 30.2609 6.30469Z",
    fill: "url(#paint4_linear_743_3970)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.2607 6.80469C34.8083 6.80966 39.1682 8.61838 42.3838 11.834C45.5994 15.0496 47.4081 19.4095 47.4131 23.957L47.3984 24.1064C47.3692 24.2525 47.2973 24.3882 47.1904 24.4951C47.0478 24.6378 46.8541 24.7177 46.6523 24.7178C46.4506 24.7178 46.2569 24.6377 46.1143 24.4951C45.9716 24.3525 45.8916 24.1588 45.8916 23.957V23.9561C45.8871 19.8122 44.2387 15.8393 41.3086 12.9092C38.3785 9.97905 34.4055 8.33074 30.2617 8.32617H30.2607C30.059 8.32614 29.8653 8.24618 29.7227 8.10352C29.58 7.96084 29.5 7.76717 29.5 7.56543C29.5 7.36368 29.58 7.17 29.7227 7.02734C29.8296 6.92042 29.9652 6.84862 30.1113 6.81934L30.2607 6.80469Z",
    stroke: "url(#paint5_linear_743_3970)",
    strokeOpacity: 0.1
  }))), /*#__PURE__*/React.createElement("foreignObject", {
    x: 26,
    y: -3,
    width: 31.2174,
    height: 31.2173
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(1.5px)",
      clipPath: "url(#bgblur_2_743_3970_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_743_3970)",
    "data-figma-bg-blur-radius": 3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.2609 0C29.9265 0 29.6058 0.132841 29.3693 0.3693C29.1328 0.605759 29 0.926466 29 1.26087C29 1.59527 29.1328 1.91598 29.3693 2.15244C29.6058 2.3889 29.9265 2.52174 30.2609 2.52174C35.9438 2.52808 41.3921 4.78842 45.4106 8.80685C49.429 12.8253 51.6893 18.2736 51.6957 23.9565C51.6957 24.2909 51.8285 24.6116 52.065 24.8481C52.3014 25.0846 52.6221 25.2174 52.9565 25.2174C53.2909 25.2174 53.6116 25.0846 53.8481 24.8481C54.0846 24.6116 54.2174 24.2909 54.2174 23.9565C54.2104 17.605 51.6842 11.5156 47.193 7.02444C42.7017 2.53324 36.6124 0.00700848 30.2609 0Z",
    fill: "#1D1D1D",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.2609 0C29.9265 0 29.6058 0.132841 29.3693 0.3693C29.1328 0.605759 29 0.926466 29 1.26087C29 1.59527 29.1328 1.91598 29.3693 2.15244C29.6058 2.3889 29.9265 2.52174 30.2609 2.52174C35.9438 2.52808 41.3921 4.78842 45.4106 8.80685C49.429 12.8253 51.6893 18.2736 51.6957 23.9565C51.6957 24.2909 51.8285 24.6116 52.065 24.8481C52.3014 25.0846 52.6221 25.2174 52.9565 25.2174C53.2909 25.2174 53.6116 25.0846 53.8481 24.8481C54.0846 24.6116 54.2174 24.2909 54.2174 23.9565C54.2104 17.605 51.6842 11.5156 47.193 7.02444C42.7017 2.53324 36.6124 0.00700848 30.2609 0Z",
    fill: "url(#paint6_linear_743_3970)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.2607 0.5C36.4797 0.506974 42.4424 2.98046 46.8398 7.37793C51.0999 11.6381 53.5545 17.3671 53.71 23.375L53.7178 23.957C53.7176 24.1586 53.6367 24.3516 53.4941 24.4941C53.3515 24.6368 53.1579 24.7178 52.9561 24.7178C52.7544 24.7176 52.5615 24.6367 52.4189 24.4941C52.2763 24.3515 52.1953 24.1579 52.1953 23.9561L52.1885 23.4111C52.0429 17.7934 49.7471 12.4366 45.7637 8.45312C41.6517 4.34132 36.0768 2.02805 30.2617 2.02148H30.2607C30.059 2.02145 29.8653 1.94149 29.7227 1.79883C29.58 1.65615 29.5 1.46248 29.5 1.26074C29.5 1.05899 29.58 0.865316 29.7227 0.722656C29.8296 0.61573 29.9652 0.54393 30.1113 0.514648L30.2607 0.5Z",
    stroke: "url(#paint7_linear_743_3970)",
    strokeOpacity: 0.1
  }))), /*#__PURE__*/React.createElement("foreignObject", {
    x: 3.30469,
    y: 6.38477,
    width: 44.5278,
    height: 44.5278
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(1.5px)",
      clipPath: "url(#bgblur_3_743_3970_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_i_743_3970)",
    "data-figma-bg-blur-radius": 3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.2614 47.9124C25.8443 47.918 21.5118 46.7007 17.7439 44.3955C13.9761 42.0902 10.9199 38.7868 8.91404 34.8514C6.90814 30.916 6.03082 26.5021 6.37925 22.0988C6.72769 17.6954 8.28828 13.4744 10.8881 9.90346C10.9953 9.75627 11.1331 9.63404 11.292 9.54517C11.4509 9.4563 11.6272 9.4029 11.8087 9.38864C11.9902 9.37438 12.1727 9.3996 12.3435 9.46257C12.5144 9.52554 12.6695 9.62476 12.7984 9.75342L44.4638 41.4189C44.5925 41.5477 44.6917 41.7029 44.7547 41.8737C44.8177 42.0446 44.8429 42.227 44.8286 42.4085C44.8144 42.5901 44.761 42.7663 44.6721 42.9252C44.5832 43.0842 44.461 43.2219 44.3138 43.3291C40.2359 46.3117 35.3136 47.9172 30.2614 47.9124Z",
    fill: "#1D1D1D",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.2614 47.9124C25.8443 47.918 21.5118 46.7007 17.7439 44.3955C13.9761 42.0902 10.9199 38.7868 8.91404 34.8514C6.90814 30.916 6.03082 26.5021 6.37925 22.0988C6.72769 17.6954 8.28828 13.4744 10.8881 9.90346C10.9953 9.75627 11.1331 9.63404 11.292 9.54517C11.4509 9.4563 11.6272 9.4029 11.8087 9.38864C11.9902 9.37438 12.1727 9.3996 12.3435 9.46257C12.5144 9.52554 12.6695 9.62476 12.7984 9.75342L44.4638 41.4189C44.5925 41.5477 44.6917 41.7029 44.7547 41.8737C44.8177 42.0446 44.8429 42.227 44.8286 42.4085C44.8144 42.5901 44.761 42.7663 44.6721 42.9252C44.5832 43.0842 44.461 43.2219 44.3138 43.3291C40.2359 46.3117 35.3136 47.9172 30.2614 47.9124Z",
    fill: "url(#paint8_linear_743_3970)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8477 9.88672C11.9572 9.87812 12.0678 9.89364 12.1709 9.93164C12.2738 9.9696 12.3667 10.03 12.4443 10.1074L44.1104 41.7725C44.1878 41.8501 44.2472 41.9439 44.2852 42.0469C44.3231 42.1499 44.3386 42.2597 44.3301 42.3691C44.3215 42.4787 44.289 42.5857 44.2354 42.6816C44.1818 42.7773 44.1082 42.8602 44.0195 42.9248L44.0186 42.9258C40.0265 45.8456 35.2076 47.4168 30.2617 47.4121H30.2607C25.9359 47.4176 21.694 46.2259 18.0049 43.9688C14.3158 41.7116 11.3233 38.4772 9.35938 34.624C7.39559 30.7711 6.53688 26.4498 6.87793 22.1387C7.21907 17.8275 8.74562 13.6935 11.291 10.1973L11.292 10.1982C11.3567 10.1094 11.4402 10.0351 11.5361 9.98145C11.6319 9.92788 11.7382 9.89534 11.8477 9.88672Z",
    stroke: "url(#paint9_linear_743_3970)",
    strokeOpacity: 0.1
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_743_3970",
    x: 26,
    y: 3.30469,
    width: 24.9131,
    height: 24.9131,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_743_3970"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_1_743_3970_clip_path",
    transform: "translate(-26 -3.30469)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.2609 6.30469C29.9265 6.30469 29.6058 6.43753 29.3693 6.67399C29.1328 6.91045 29 7.23115 29 7.56556C29 7.89996 29.1328 8.22067 29.3693 8.45713C29.6058 8.69359 29.9265 8.82643 30.2609 8.82643C34.2724 8.83077 38.1183 10.4263 40.9549 13.2628C43.7915 16.0994 45.387 19.9454 45.3913 23.9569C45.3913 24.2913 45.5241 24.612 45.7606 24.8484C45.9971 25.0849 46.3178 25.2177 46.6522 25.2177C46.9866 25.2177 47.3073 25.0849 47.5437 24.8484C47.7802 24.612 47.913 24.2913 47.913 23.9569C47.908 19.2768 46.0467 14.7898 42.7373 11.4804C39.428 8.17108 34.941 6.30969 30.2609 6.30469Z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_743_3970",
    x: 26,
    y: -3,
    width: 31.2174,
    height: 31.2173,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_743_3970"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_2_743_3970_clip_path",
    transform: "translate(-26 3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.2609 0C29.9265 0 29.6058 0.132841 29.3693 0.3693C29.1328 0.605759 29 0.926466 29 1.26087C29 1.59527 29.1328 1.91598 29.3693 2.15244C29.6058 2.3889 29.9265 2.52174 30.2609 2.52174C35.9438 2.52808 41.3921 4.78842 45.4106 8.80685C49.429 12.8253 51.6893 18.2736 51.6957 23.9565C51.6957 24.2909 51.8285 24.6116 52.065 24.8481C52.3014 25.0846 52.6221 25.2174 52.9565 25.2174C53.2909 25.2174 53.6116 25.0846 53.8481 24.8481C54.0846 24.6116 54.2174 24.2909 54.2174 23.9565C54.2104 17.605 51.6842 11.5156 47.193 7.02444C42.7017 2.53324 36.6124 0.00700848 30.2609 0Z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_743_3970",
    x: 3.30469,
    y: 6.38477,
    width: 44.5278,
    height: 44.5278,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_743_3970"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_3_743_3970_clip_path",
    transform: "translate(-3.30469 -6.38477)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.2614 47.9124C25.8443 47.918 21.5118 46.7007 17.7439 44.3955C13.9761 42.0902 10.9199 38.7868 8.91404 34.8514C6.90814 30.916 6.03082 26.5021 6.37925 22.0988C6.72769 17.6954 8.28828 13.4744 10.8881 9.90346C10.9953 9.75627 11.1331 9.63404 11.292 9.54517C11.4509 9.4563 11.6272 9.4029 11.8087 9.38864C11.9902 9.37438 12.1727 9.3996 12.3435 9.46257C12.5144 9.52554 12.6695 9.62476 12.7984 9.75342L44.4638 41.4189C44.5925 41.5477 44.6917 41.7029 44.7547 41.8737C44.8177 42.0446 44.8429 42.227 44.8286 42.4085C44.8144 42.5901 44.761 42.7663 44.6721 42.9252C44.5832 43.0842 44.461 43.2219 44.3138 43.3291C40.2359 46.3117 35.3136 47.9172 30.2614 47.9124Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_743_3970",
    x1: 29,
    y1: 6.30469,
    x2: 51.279,
    y2: 11.9617,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FF97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#2C32FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_743_3970",
    x1: 3.7832,
    y1: 32.7832,
    x2: 33.4885,
    y2: 40.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FF97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#2C32FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_743_3970",
    x1: 21.752,
    y1: 18.9121,
    x2: 38.8297,
    y2: 23.2477,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FF97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#2C32FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_743_3970",
    x1: 29,
    y1: 12.6094,
    x2: 43.8527,
    y2: 16.3807,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FF97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#2C32FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_743_3970",
    x1: 29,
    y1: 6.30469,
    x2: 51.279,
    y2: 11.9617,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#87FFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.776042,
    stopColor: "#5C6DFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_743_3970",
    x1: 29.591,
    y1: 7.16437,
    x2: 47.913,
    y2: 7.16437,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CDEB6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#364AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_743_3970",
    x1: 29,
    y1: 0,
    x2: 58.7053,
    y2: 7.54273,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#87FFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.776042,
    stopColor: "#5C6DFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_743_3970",
    x1: 29.788,
    y1: 1.14625,
    x2: 54.2174,
    y2: 1.14625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CDEB6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#364AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_743_3970",
    x1: 6.30469,
    y1: 9.38477,
    x2: 51.6892,
    y2: 20.9088,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#87FFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.776042,
    stopColor: "#5C6DFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_743_3970",
    x1: 7.50868,
    y1: 11.136,
    x2: 44.8325,
    y2: 11.136,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CDEB6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#364AFF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_743_3970"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 58,
    height: 58,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatureIcon01);
export default __webpack_public_path__ + "static/media/feature-icon01.8307fc69eb997694a57c2260b4508a03.svg";
export { ForwardRef as ReactComponent };